import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";
import { isString } from 'lodash';

const toastError = err => {
	console.log('toastError received:', err); // Debug log

	// Tentar várias possibilidades de estrutura de erro
	const fullErrorMsg = err.response?.data?.error ||
	                     err.response?.data?.message ||
	                     err.message ||
	                     err.error;

	console.log('Extracted error message:', fullErrorMsg); // Debug log

	if (fullErrorMsg) {
		// Verificar se é uma mensagem com chave de tradução (formato: ERR_CODE: detalhes)
		const errorParts = fullErrorMsg.split(':');
		const errorKey = errorParts[0].trim();
		const errorDetails = errorParts.length > 1 ? errorParts.slice(1).join(':').trim() : '';

		console.log('Error key:', errorKey, 'Details:', errorDetails); // Debug log

		if (i18n.exists(`backendErrors.${errorKey}`)) {
			// Usar a tradução e adicionar detalhes se existirem
			const translatedMessage = i18n.t(`backendErrors.${errorKey}`);
			const finalMessage = errorDetails ? `${translatedMessage}\n${errorDetails}` : translatedMessage;

			toast.error(finalMessage, {
				toastId: errorKey,
				autoClose: 4000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
				theme: "light",
			});
			return
		} else {
			// Fallback para a mensagem original
			toast.error(fullErrorMsg, {
				toastId: fullErrorMsg,
				autoClose: 4000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
				theme: "light",
			});
			return
		}
	} if (isString(err)) {
		toast.error(err);
		return
	} else {
		toast.error("An error occurred!");
		return
	}
};

export default toastError;
